module.exports = __webpack_public_path__ + "img/footer-logo.d29c8d03.png";